export default {
	"refund.CopiedSuccessfully": "已成功複製!",
	"refund.ReplicationIsNotSupported": "不支持複製",
	"refund.RefundSuccessfully": "退款成功",
	"refund.ParameterError": "參數錯誤!",
	"refund.callOfficial": "叫叫官方",
	"refund.RefundInformation": "退款信息",
	"refund.refundOrderNumber": "退款單號",
	"refund.copy": "複製",
	"refund.RefundType": "退款類型",
	"refund.reasonForReturn": "退款原因",
	"refund.TotalAmountRefunded": "實退總金額",
	"refund.RefundInstructions": "退款說明"
}